import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Primarytheme from './utility/theme';

import { styled } from '@mui/material/styles';

import History from './History';
import Launch from './utility/Launch';

import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';


import IconButton from '@mui/material/IconButton';
import Refresh from '@mui/icons-material/Refresh'
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import Tooltip from "@mui/material/Tooltip";

const breaksLaunch = { xs: 320, sm: 450, md: 600, lg: 900, xl: 1200 };
const breaksHistory = breaksLaunch;

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    margin: 0, //'1em',
    textAlign: 'left',
    //color: Primarytheme.palette.primary.main,
    fontSize: '16px',
    //fontWeight: 'bold',
    background: 'white',
    boxShadow: '0px 0px 0px 0px, 1px 1px 5px 0px rgb(0 0 0 / 14%), 0px 0px 0px 0px rgb(0 0 0 / 12%)',
    //border: '100px',
    //variant: 'outlined',
    borderRadius: '10px'
}));


export default function Dashboard({ auth }) {

    const [parentForceRefresh, setParentForceRefresh] = useState(0);

    const history = useHistory();
    const redirect = (dst) => {
        history.push(dst);
    }

    useEffect(() => {
        setParentForceRefresh(parentForceRefresh => parentForceRefresh + 1)
    }, [auth.userState.attached_projects]);


    return (
        <Grid
            container
            flexDirection={'row'}
            sx={{
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: '3em',
                marginBottom: '2em'
            }}
            rowSpacing={3}
            columnSpacing={3}
        >
            <Grid id='launch' size={12} >
                <Item key='Stepper' sx={{ width: {...breaksLaunch}}}>
                    <Launch auth={auth} setParentForceRefresh={setParentForceRefresh} />
                </Item>
            </Grid>

            <Grid container id='requests' size={12}>
                <Item key='Requests' sx={{ width: {...breaksLaunch}}}>
                    <Stack direction='row' justifyContent="space-between" >
                        <Typography variant='h5' color={Primarytheme.palette.primary.main} >
                            <b>Latest Requests</b>
                        </Typography>
                        <Box >
                            <Tooltip title="Open full history in new tab">
                                <IconButton onClick={() => window.open("/history", "_blank")} > <OpenInNewIcon /> </IconButton>
                            </Tooltip>
                            <IconButton onClick={() => setParentForceRefresh(parentForceRefresh => parentForceRefresh + 1)} > <Refresh /> </IconButton>
                        </Box>
                    </Stack>

                    <History auth={auth} parentForceRefresh={parentForceRefresh} itemsToShow={4} inDashBoard={true} />
                </Item>
            </Grid>

        </Grid >


    )


}
